var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _line, _line2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhoviewmyprofile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    rx: 11,
    fill: "url(#paint0_linear_4819_3490)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.2946 51.4576H19.4387C18.6441 51.4576 18 50.8284 18 50.0522V15.4054C18 14.6292 18.6441 14 19.4387 14H47.2946C48.0892 14 48.7333 14.6292 48.7333 15.4054V50.0522C48.7333 50.8284 48.0892 51.4576 47.2946 51.4576Z",
    fill: "#F7F5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2946 14H19.4387C18.6441 14 18 14.6292 18 15.4054V15.8844H45.3655C46.1601 15.8844 46.8042 16.5136 46.8042 17.2898V51.4574H47.2946C48.0892 51.4574 48.7333 50.8282 48.7333 50.052V15.4054C48.7333 14.6292 48.0892 14 47.2946 14Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2948 14H19.4389C17 14 17.1779 14.4207 17 15C17.131 14.9616 18.3304 14.9422 18.4743 14.9422H46.3302C47.1248 14.9422 47.7689 15.5714 47.7689 16.3476V50.9944C47.7689 51.1349 47.7477 51.2704 47.7084 51.3986C48.3014 51.225 48.7335 50.688 48.7335 50.0522V15.4054C48.7335 14.6292 48.0894 14 47.2948 14Z",
    fill: "url(#paint1_linear_4819_3490)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1722 30.55C30.265 30.55 32.7722 27.8727 32.7722 24.5701C32.7722 21.2675 30.265 18.5902 27.1722 18.5902C24.0794 18.5902 21.5723 21.2675 21.5723 24.5701C21.5723 27.8727 24.0794 30.55 27.1722 30.55Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4458 18.7455C29.6715 19.8425 30.4507 21.4892 30.4507 23.3305C30.4507 26.6332 27.9436 29.3104 24.8507 29.3104C24.4127 29.3104 23.9863 29.2565 23.5771 29.1549C24.5498 30.0255 25.8037 30.5498 27.1722 30.5498C30.265 30.5498 32.7722 27.8726 32.7722 24.5699C32.7722 21.7352 30.9249 19.3612 28.4458 18.7455Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2406 28.6786C30.9215 29.0393 30.5604 29.3579 30.1658 29.6242C29.2999 30.2106 28.2726 30.5502 27.1711 30.5502C25.5682 30.5502 24.123 29.8313 23.1016 28.6786C23.3826 27.6386 24.2798 26.8789 25.344 26.8789H28.998C30.0624 26.8787 30.9596 27.6386 31.2406 28.6786Z",
    fill: "#478CF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1697 29.6243V28.7479C30.1697 28.0253 29.8806 27.3734 29.4199 26.9183C30.2962 27.088 31.002 27.7784 31.2445 28.6784C30.9251 29.0393 30.5642 29.3577 30.1697 29.6243Z",
    fill: "#377DE2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5029 25.5425V27.3147C26.5029 27.4519 26.5398 27.5861 26.6091 27.7015C26.8729 28.1407 27.4741 28.1407 27.7379 27.7015C27.8072 27.5861 27.8441 27.4519 27.8441 27.3147V25.5425H26.5029Z",
    fill: "#FCC4AE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5029 26.0966C26.7138 26.172 26.939 26.2134 27.1736 26.2134C27.4082 26.2134 27.6335 26.172 27.8443 26.0966V25.5425H26.5029V26.0966Z",
    fill: "#F2AD97"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1732 25.9018C26.006 25.9018 25.0596 24.8912 25.0596 23.6448V22.4733C25.0596 21.2269 26.006 20.2163 27.1732 20.2163C28.3404 20.2163 29.2868 21.2269 29.2868 22.4733V23.6448C29.2868 24.8914 28.3404 25.9018 27.1732 25.9018Z",
    fill: "#FFD2C0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0596 22.4733V23.0757C25.8833 22.4885 26.4101 21.4869 26.4069 20.3885C26.4069 20.3822 26.4069 20.3756 26.4069 20.3693C25.6182 20.697 25.0596 21.5155 25.0596 22.4733Z",
    fill: "#F2AD97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5146 20.7291C28.8147 21.1188 28.995 21.6177 28.995 22.1615V23.333C28.995 24.5794 28.0486 25.59 26.8814 25.59C26.372 25.59 25.9049 25.3974 25.54 25.077C25.9276 25.5805 26.5153 25.9016 27.1732 25.9016C28.3404 25.9016 29.2868 24.891 29.2868 23.6446V22.4731C29.2868 21.7707 28.9861 21.1432 28.5146 20.7291Z",
    fill: "#FCC4AE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0608 23.6448V22.9395C24.6848 22.9395 24.3799 23.2649 24.3799 23.6665C24.3799 24.0682 24.6846 24.3936 25.0608 24.3936C25.1004 24.3936 25.1389 24.3893 25.1767 24.3823C25.1019 24.151 25.0608 23.9032 25.0608 23.6448Z",
    fill: "#FFD2C0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2868 22.9395V23.6448C29.2868 23.9032 29.2457 24.151 29.1709 24.3823C29.2086 24.3893 29.2472 24.3936 29.2868 24.3936C29.6627 24.3936 29.9677 24.0682 29.9677 23.6665C29.9677 23.2649 29.6627 22.9395 29.2868 22.9395Z",
    fill: "#FFD2C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7066 23.094C29.7971 23.2176 29.8511 23.373 29.8511 23.5421C29.8511 23.9313 29.5648 24.249 29.2048 24.2682C29.1944 24.3067 29.1832 24.3449 29.1709 24.3825C29.2086 24.3895 29.2472 24.3938 29.2868 24.3938C29.6627 24.3938 29.9677 24.0684 29.9677 23.6668C29.9679 23.4339 29.8658 23.2271 29.7066 23.094Z",
    fill: "#FCC4AE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4066 19.7653C26.4102 20.9637 25.7826 22.0472 24.8268 22.6025C24.6247 22.72 24.3765 22.5509 24.3967 22.3061C24.4653 21.4745 24.8116 20.7135 25.3556 20.1774C25.6495 19.8866 26.001 19.6626 26.3977 19.528C26.4037 19.6062 26.4066 19.6852 26.4066 19.7653Z",
    fill: "#7C3108"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7772 22.4048C28.0054 23.3814 25.778 22.2667 25.3555 20.1772C25.6477 19.8882 25.9971 19.6649 26.3911 19.53C28.0383 18.9591 29.6797 20.2976 29.93 22.0866C29.9478 22.216 29.8861 22.3448 29.7772 22.4048Z",
    fill: "#8C3F0A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.93 22.0866C29.8101 21.2285 29.37 20.4741 28.7628 19.9842C29.0635 20.4071 29.2727 20.9156 29.3498 21.4668C29.3678 21.596 29.306 21.725 29.1973 21.785C28.0941 22.3932 26.8141 22.1902 25.9033 21.4462C26.7751 22.6675 28.4117 23.1576 29.7777 22.4045C29.8862 22.3448 29.9481 22.216 29.93 22.0866Z",
    fill: "#7C3108"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0601 23.6448V23.2488C24.844 23.2488 24.6689 23.4359 24.6689 23.6665C24.6689 23.8971 24.8442 24.0843 25.0601 24.0843C25.0739 24.0843 25.0868 24.0813 25.1002 24.08C25.0745 23.939 25.0601 23.7937 25.0601 23.6448Z",
    fill: "#F2AD97"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2871 23.6448V23.2488C29.5033 23.2488 29.6783 23.4359 29.6783 23.6665C29.6783 23.8971 29.5031 24.0843 29.2871 24.0843C29.2733 24.0843 29.2604 24.0813 29.2471 24.08C29.2729 23.939 29.2871 23.7937 29.2871 23.6448Z",
    fill: "#F2AD97"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6816 26.8786L27.4165 30.5438C27.3353 30.5474 27.2539 30.5499 27.1728 30.5499C27.0916 30.5499 27.0102 30.5474 26.9291 30.5438L25.665 26.8786L26.4995 26.4758V26.8626L27.1728 27.9818L27.846 26.8626V26.4758L28.6816 26.8786Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.665 26.8783L26.2948 28.7026C26.3205 28.7768 26.4095 28.7976 26.4618 28.7417L27.173 27.9823L26.5002 26.8626V26.4757L25.665 26.8783Z",
    fill: "#F1F2F2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6805 26.8783L28.05 28.7026C28.0244 28.7768 27.9354 28.7976 27.883 28.7417L27.1719 27.9823L27.8447 26.8626V26.4757L28.6805 26.8783Z",
    fill: "#F1F2F2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7367 28.5838L27.3171 29.0318C27.2378 29.1165 27.1092 29.1165 27.0299 29.0318L26.6104 28.5838L27.1736 27.9823L27.7367 28.5838Z",
    fill: "#E63950"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5866 30.0544L27.4183 30.5441C27.3372 30.5477 27.2558 30.5502 27.1746 30.5502C27.0935 30.5502 27.0121 30.5477 26.931 30.5441L26.7627 30.0544L26.8869 28.8782L27.0308 29.0318C27.1109 29.116 27.2384 29.116 27.3185 29.0318L27.4624 28.8782L27.5866 30.0544Z",
    fill: "#B7022D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9298 30.5439C26.7963 30.5389 26.6651 30.5278 26.5352 30.5104L25.1807 28.9438C25.1423 28.8992 25.1447 28.8297 25.1887 28.7901L25.5462 28.453C25.6123 28.3898 25.5776 28.2733 25.4905 28.2633L25.0692 28.2149C25.0042 28.2074 24.9624 28.1368 24.9845 28.0699L25.3896 26.8787H25.666L26.9298 30.5439Z",
    fill: "#5E9CF7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2766 28.2149L28.8553 28.2633C28.7682 28.2733 28.7335 28.3898 28.7996 28.453L29.1571 28.7901C29.2012 28.8297 29.2035 28.8992 29.1651 28.9438L27.8106 30.5104C27.6807 30.5278 27.5495 30.5389 27.416 30.5439L28.6811 26.8787H28.9575L29.3614 28.0699C29.3834 28.1368 29.3416 28.2074 29.2766 28.2149Z",
    fill: "#5E9CF7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.768 37.1913H26.0846C25.7649 37.1913 25.5059 36.9382 25.5059 36.6259C25.5059 36.3137 25.7649 36.0606 26.0846 36.0606H31.7678C32.0875 36.0606 32.3466 36.3137 32.3466 36.6259C32.3466 36.9382 32.0877 37.1913 31.768 37.1913Z",
    fill: "#939598"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0297 37.1913H21.5729C21.2532 37.1913 20.9941 36.9382 20.9941 36.6259C20.9941 36.3137 21.2532 36.0606 21.5729 36.0606H24.0297C24.3494 36.0606 24.6085 36.3137 24.6085 36.6259C24.6085 36.9382 24.3494 37.1913 24.0297 37.1913Z",
    fill: "#58595B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.768 40.605H26.0846C25.7649 40.605 25.5059 40.352 25.5059 40.0397C25.5059 39.7275 25.7649 39.4744 26.0846 39.4744H31.7678C32.0875 39.4744 32.3466 39.7275 32.3466 40.0397C32.3466 40.352 32.0877 40.605 31.768 40.605Z",
    fill: "#939598"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0297 40.605H21.5729C21.2532 40.605 20.9941 40.352 20.9941 40.0397C20.9941 39.7275 21.2532 39.4744 21.5729 39.4744H24.0297C24.3494 39.4744 24.6085 39.7275 24.6085 40.0397C24.6085 40.352 24.3494 40.605 24.0297 40.605Z",
    fill: "#58595B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.768 44.0188H26.0846C25.7649 44.0188 25.5059 43.7658 25.5059 43.4535C25.5059 43.1413 25.7649 42.8882 26.0846 42.8882H31.7678C32.0875 42.8882 32.3466 43.1413 32.3466 43.4535C32.3466 43.7658 32.0877 44.0188 31.768 44.0188Z",
    fill: "#939598"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0297 44.0188H21.5729C21.2532 44.0188 20.9941 43.7658 20.9941 43.4535C20.9941 43.1413 21.2532 42.8882 21.5729 42.8882H24.0297C24.3494 42.8882 24.6085 43.1413 24.6085 43.4535C24.6085 43.7658 24.3494 44.0188 24.0297 44.0188Z",
    fill: "#58595B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M31.768 47.4327H26.0846C25.7649 47.4327 25.5059 47.1796 25.5059 46.8673C25.5059 46.5551 25.7649 46.302 26.0846 46.302H31.7678C32.0875 46.302 32.3466 46.5551 32.3466 46.8673C32.3466 47.1796 32.0877 47.4327 31.768 47.4327Z",
    fill: "#939598"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0297 47.4327H21.5729C21.2532 47.4327 20.9941 47.1796 20.9941 46.8673C20.9941 46.5551 21.2532 46.302 21.5729 46.302H24.0297C24.3494 46.302 24.6085 46.5551 24.6085 46.8673C24.6085 47.1796 24.3494 47.4327 24.0297 47.4327Z",
    fill: "#58595B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.161 47.4327H35.7906C35.471 47.4327 35.2119 47.1796 35.2119 46.8673C35.2119 46.5551 35.471 46.302 35.7906 46.302H45.161C45.4806 46.302 45.7397 46.5551 45.7397 46.8673C45.7397 47.1796 45.4806 47.4327 45.161 47.4327Z",
    fill: "#939598"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M45.161 44.0188H35.7906C35.471 44.0188 35.2119 43.7658 35.2119 43.4535C35.2119 43.1413 35.471 42.8882 35.7906 42.8882H45.161C45.4806 42.8882 45.7397 43.1413 45.7397 43.4535C45.7397 43.7658 45.4806 44.0188 45.161 44.0188Z",
    fill: "#939598"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M45.161 40.605H35.7906C35.471 40.605 35.2119 40.352 35.2119 40.0397C35.2119 39.7275 35.471 39.4744 35.7906 39.4744H45.161C45.4806 39.4744 45.7397 39.7275 45.7397 40.0397C45.7397 40.352 45.4806 40.605 45.161 40.605Z",
    fill: "#939598"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M45.161 37.1913H35.7906C35.471 37.1913 35.2119 36.9382 35.2119 36.6259C35.2119 36.3137 35.471 36.0606 35.7906 36.0606H45.161C45.4806 36.0606 45.7397 36.3137 45.7397 36.6259C45.7397 36.9382 45.4806 37.1913 45.161 37.1913Z",
    fill: "#939598"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1057 33.7773H35.7906C35.471 33.7773 35.2119 33.5242 35.2119 33.212C35.2119 32.8997 35.471 32.6466 35.7906 32.6466H43.1057C43.4254 32.6466 43.6844 32.8997 43.6844 33.212C43.6844 33.5242 43.4255 33.7773 43.1057 33.7773Z",
    fill: "#FF7705",
    fillOpacity: 0.88
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1609 26.9499H35.6774C35.3577 26.9499 35.0986 26.6968 35.0986 26.3845C35.0986 26.0723 35.3577 25.8192 35.6774 25.8192H45.1609C45.4806 25.8192 45.7396 26.0723 45.7396 26.3845C45.7396 26.6968 45.4806 26.9499 45.1609 26.9499Z",
    fill: "#939598"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1609 23.5361H35.6774C35.3577 23.5361 35.0986 23.283 35.0986 22.9707C35.0986 22.6585 35.3577 22.4054 35.6774 22.4054H45.1609C45.4806 22.4054 45.7396 22.6585 45.7396 22.9707C45.7396 23.283 45.4806 23.5361 45.1609 23.5361Z",
    fill: "#939598"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9372 20.1223H35.6774C35.3577 20.1223 35.0986 19.8692 35.0986 19.5569C35.0986 19.2447 35.3577 18.9916 35.6774 18.9916H40.9372C41.2568 18.9916 41.5159 19.2447 41.5159 19.5569C41.5159 19.8692 41.2568 20.1223 40.9372 20.1223Z",
    fill: "#E60000",
    fillOpacity: 0.81
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3945 34.5C51.3129 34.5 55.29 38.5353 55.29 43.5C55.29 48.4647 51.3129 52.5 46.3945 52.5C41.4763 52.4997 37.5 48.4645 37.5 43.5C37.5 38.5355 41.4763 34.5003 46.3945 34.5Z",
    fill: "url(#paint2_linear_4819_3490)",
    stroke: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5351 45.0375L43.548 44.0752L43.5479 44.0749L44.5351 45.0375Z",
    fill: "#377DE2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3349 40C43.9208 40 41.8705 42.2192 41.1353 43.1235C40.9549 43.3454 40.9549 43.6546 41.1353 43.8765C41.8705 44.7808 43.9206 47 46.3349 47C48.7493 47 50.7994 44.7808 51.5346 43.8765C51.715 43.6546 51.715 43.3454 51.5346 43.1235C50.7994 42.2192 48.7493 40 46.3349 40Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5323 43.1235C51.2805 42.8138 50.8742 42.3497 50.3519 41.8732C50.7188 42.2359 51.0105 42.5724 51.2073 42.8144C51.3877 43.0363 51.3877 43.3457 51.2073 43.5675C50.4722 44.4717 48.422 46.6909 46.0077 46.6909C44.4205 46.6909 42.9906 45.7317 41.9883 44.8176C42.9922 45.8099 44.5645 47 46.3327 47C48.7468 47 50.7972 44.7808 51.5323 43.8765C51.7127 43.6546 51.7127 43.3452 51.5323 43.1235Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3335 46.2281C47.9179 46.2281 49.2022 45.0067 49.2022 43.4999C49.2022 41.9932 47.9179 40.7718 46.3335 40.7718C44.7492 40.7718 43.4648 41.9932 43.4648 43.4999C43.4648 45.0067 44.7492 46.2281 46.3335 46.2281Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1929 41.4237C48.6194 41.9 48.8783 42.5161 48.8783 43.1909C48.8783 44.6976 47.5939 45.919 46.0096 45.919C45.3003 45.919 44.6522 45.6728 44.1514 45.2671C44.6776 45.8544 45.4597 46.2281 46.3346 46.2281C47.919 46.2281 49.2033 45.0066 49.2033 43.4999C49.2033 42.6679 48.8104 41.9241 48.1929 41.4237Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3326 44.757C47.0626 44.757 47.6544 44.1942 47.6544 43.4999C47.6544 42.8057 47.0626 42.2429 46.3326 42.2429C45.6025 42.2429 45.0107 42.8057 45.0107 43.4999C45.0107 44.1942 45.6025 44.757 46.3326 44.757Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3101 43.6565C47.7937 43.6565 48.1857 43.2837 48.1857 42.8238C48.1857 42.3639 47.7937 41.9911 47.3101 41.9911C46.8266 41.9911 46.4346 42.3639 46.4346 42.8238C46.4346 43.2837 46.8266 43.6565 47.3101 43.6565Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7431 42.1038C47.8164 42.2256 47.8615 42.3645 47.8615 42.5149C47.8615 42.9748 47.4696 43.3475 46.986 43.3475C46.828 43.3475 46.6818 43.3046 46.5537 43.2349C46.7047 43.4857 46.9853 43.6566 47.311 43.6566C47.7946 43.6566 48.1866 43.2839 48.1866 42.824C48.1864 42.5143 48.0067 42.2472 47.7431 42.1038Z",
    fill: "#F1F2F2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 14.5,
    x2: 17.5,
    y2: 52.5,
    stroke: "url(#paint3_linear_4819_3490)",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41.5,
    y1: 52.5,
    x2: 17.5,
    y2: 52.5,
    stroke: "url(#paint4_linear_4819_3490)",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4819_3490",
    x1: 33.5,
    y1: 0,
    x2: 33.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4819_3490",
    x1: 33.397,
    y1: 14,
    x2: 33.397,
    y2: 51.3986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4819_3490",
    x1: 46.395,
    y1: 35,
    x2: 46.395,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4819_3490",
    x1: 16.5,
    y1: 14,
    x2: 16.5,
    y2: 53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4819_3490",
    x1: 42,
    y1: 51.5,
    x2: 17,
    y2: 51.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhoviewmyprofile);
export default __webpack_public_path__ + "static/media/WHOVIEWMYPROFILE.b63dc5c3bfb5041920be9d5e6d481a67.svg";
export { ForwardRef as ReactComponent };